import translations from '../../../player/overlay-actions/translations';


export default function getPurchaseStatusConfig({ dgsInfo }) {
  const saleInfo = _.get(dgsInfo, 'sale');

  if (!saleInfo) {
    return null;
  }

  return {
    translationData: {
      props: translations.saleInfo,
    },
  };
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/components/selectors/purchase-status.js